<h5 mat-dialog-title i18n>Inventory Report</h5>
<div mat-dialog-content>
  <form #parameterForm="ngForm" class="flex-row" (ngSubmit)="runReport(parameterForm)">
    <div class="col-sm-6">
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="itemSearch" i18n>Item Search</label>
        </div>
        <input id="itemSearch" name="itemSearch" class="form-control" [(ngModel)]="parms.itemSearch">
      </div>
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="itemTypes" i18n>Type</label>
        </div>
        <mat-select multiple name="itemTypes" id="itemTypes" class="form-control" [(value)]="selectedItemTypes">
          <mat-option [value]="null" selected="">-</mat-option>
          <mat-option *ngFor="let type of parms.itemTypes" [value]="type.itemType_ID">{{type.itemType_Desc}}</mat-option>
        </mat-select>
      </div>
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="rValues" i18n>R-Value</label>
        </div>
        <select name="rValues" id="rValues" class="form-control select-bidit" [(ngModel)]="this.parms.rValueId">
          <option [ngValue]="null" selected="">-</option>
          <option *ngFor="let rvalue of this.parms.rValues" [(ngValue)]="rvalue.rValue_ID">{{rvalue.rValue_Desc}}</option>
        </select>
      </div>
      <div class="form-group">
        <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
        <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="statusId" i18n>Status</label>
        </div>
        <select name="statusId" id="statusId" class="form-control select-bidit" [(ngModel)]="parms.statusId">
          <option [ngValue]="null" selected="" i18n>All</option>
          <option [ngValue]=1 i18n>Active</option>
          <option [ngValue]=0 i18n>Inactive</option>
        </select>
      </div>
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="vendorId" i18n>Vendor</label>
        </div>
        <select name="vendors" id="vendors" class="form-control select-bidit" [(ngModel)]="parms.vendorId">
          <option [ngValue]="null" selected="">-</option>
          <option *ngFor="let vendor of parms.vendors" [(ngValue)]="vendor.vendor_ID">{{vendor.vendor_BusinessName}}</option>
        </select>
      </div>
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="warehouseId" i18n>Warehouse</label>
        </div>
        <select name="warehouses" id="warehouses" class="form-control select-bidit" [(ngModel)]="parms.warehouseId">
          <option [ngValue]="null" selected="">-</option>
          <option *ngFor="let wh of parms.warehouses" [(ngValue)]="wh.warehouse_ID">{{wh.warehouse_Name}}</option>
        </select>
      </div>
    </div>
    
  </form>
</div>
